import { motion } from "framer-motion";

// Variantes de animação para páginas
export const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: "easeIn",
    },
  },
};

// Variantes para itens em listas
export const listItemVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

// Variantes para elementos que aparecem com fade
export const fadeInVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.4 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

// Variantes para elementos que aparecem escalando
export const scaleVariants = {
  initial: { opacity: 0, scale: 0.9 },
  animate: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0, scale: 0.9, transition: { duration: 0.2 } },
};

// Variantes para slide de elementos
export const slideInVariants = {
  left: {
    initial: { opacity: 0, x: -50 },
    animate: { opacity: 1, x: 0, transition: { duration: 0.4 } },
    exit: { opacity: 0, x: -50, transition: { duration: 0.3 } },
  },
  right: {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0, transition: { duration: 0.4 } },
    exit: { opacity: 0, x: 50, transition: { duration: 0.3 } },
  },
  up: {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    exit: { opacity: 0, y: 50, transition: { duration: 0.3 } },
  },
  down: {
    initial: { opacity: 0, y: -50 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
    exit: { opacity: 0, y: -50, transition: { duration: 0.3 } },
  },
};

// Animação de hover para elementos clicáveis
export const hoverVariants = {
  hover: {
    scale: 1.05,
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
    transition: { duration: 0.2 },
  },
};

// 3D animation variants
export const card3DVariants = {
  initial: { 
    opacity: 0, 
    y: 20, 
    rotateX: 15, 
    rotateY: 10 
  },
  animate: { 
    opacity: 1, 
    y: 0, 
    rotateX: 0, 
    rotateY: 0,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 15
    }
  },
  hover: {
    y: -10,
    rotateX: -5,
    rotateY: 5,
    scale: 1.02,
    boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.15)",
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 10
    }
  }
};

// Floating animation variants
export const floatingVariants = {
  initial: {
    y: 0
  },
  animate: {
    y: [-10, 10, -10],
    transition: {
      duration: 6,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

// Card stack variants
export const cardStackVariants = {
  hidden: (i: number) => ({
    opacity: 0,
    y: 20,
    rotateZ: 5,
    rotateY: 5
  }),
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    rotateZ: 0,
    rotateY: 0,
    transition: {
      delay: i * 0.1,
      type: "spring",
      stiffness: 100,
      damping: 12
    }
  }),
  hover: {
    y: -10,
    rotateY: 8,
    scale: 1.03,
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 10
    }
  }
};
